module.exports = __webpack_public_path__ + "static/uidesignwhite-894c946cbc8d9b6968345b38704157b2.png";